import PropTypes from "prop-types";
import React from "react";

const EmptyCart = ({handleCloseCartModal}) => (
  <div className="cart-info">
    <div className="py-10 text-center text-lg font-sans-demibold">
      Your cart is empty
    </div>
    <div className="flex flex-col justify-center items-center gap-5 w-72 mx-auto">
      <button
        className="btn btn-primary w-full"
        onClick={handleCloseCartModal}
        type="button"
      >
        Keep Shopping
      </button>
      <a
        className="button-outlined-white w-full"
        href="/jewelry"
      >
        Shop All
      </a>
      <a
        className="button-outlined-white w-full"
        href="/jewelry?sort-best_selling"
      >
        Best Sellers
      </a>
      <a
        className="button-outlined-white w-full"
        href="/jewelry?my_rocksbox-new_arrivals"
      >
        New Arrivals
      </a>
    </div>
  </div>
);

EmptyCart.propTypes = {"handleCloseCartModal": PropTypes.func.isRequired};

// eslint-disable-next-line react/no-multi-comp, react/display-name
export default props => <EmptyCart {...props} />;
